import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Sleepy Guard Division',
		description:
			'Train guards to sleep with their eyes open. Maximum efficiency!'
	},
	{
		name: 'Cardboard Cutout Security',
		description:
			'Replace half the security team with cardboard cutouts. No one can tell the difference.'
	},
	{
		name: 'Invisible Force Field',
		description:
			'Install imaginary force fields. Guards spend hours pretending to bounce off them.'
	},
	{
		name: 'Quantum Security Team',
		description:
			'Guards exist in multiple states simultaneously, mostly the coffee break state.'
	},
	{
		name: 'Time Police',
		description:
			'Hire security from the future. They keep arresting people for crimes not yet committed.'
	},
	{
		name: 'Parallel Universe Guards',
		description:
			'Import security from alternate realities where everyone is asleep.'
	},
	{
		name: 'Interdimensional Security',
		description:
			'Guards patrol between dimensions. Mostly getting lost between coffee breaks.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Private Security'],
	departments[DepartmentIds['Private Security']].basePrice * 3,
	UpgradeIds.PrsExponent1
)

export default array
